module.exports = __webpack_public_path__ + "img/chapter-1-thumb.bf7aa84a.jpg";